// A short tactile tick when an item is completed. Uses the Vibration API where
// available (Android web / WebView with the VIBRATE permission); a harmless
// no-op on iOS and desktop. For real iOS haptics, add @capacitor/haptics and
// trigger it from here.
export const haptic = () => {
    try {
        if ('vibrate' in navigator) navigator.vibrate(8)
    } catch {
        /* ignore — haptics are a nice-to-have */
    }
}
